module.exports = __webpack_public_path__ + "static/media/linkedin.a64fa635.svg";